import * as utils from './utils.js';
import * as ui from './ui.js';
import config from './config.js';
import * as apihandler from './api-handler.js';
import * as log from './log.js';
/**
 * validate the file input from user , user must upload file or continue without file
 * 
 */
const navigator = window.navigator;

//========Validation Functions ========//
/**
 * validate the file input from user , user must upload file or continue without file
 * @returns {string} message shows to user
 */
export function validateInputFile() {
  let message = "";
  if (utils.isFacebookApp()) {
    message = `❌ يجب رفع صورة أو يمكنك المتابعة بالضغط على بدون صورة.<br/>
    <span style="color: #000;font-size:1rem;">⚠️ بعض إصدارات تطبيق فيسبوك لا تدعم هذه الميزة، وفي هذه الحالة يمكنك فتح الموقع عبر متصفح جهازك.</span>`;
  } else {
    message = `❌ يجب رفع صورة أو يمكنك المتابعة بالضغط على بدون صورة.`
  }
  return message;
}
/**
 * validate the length of input text and show warning if exceed max length
 * and make vibration on mobile devices with better user experience
 * @param {string} input 
 * @returns {void}
 */
export function validateLength(input) {

  if (!input.maxLength || input.maxLength <= 0) return; // Exit if maxLength is not set

  const maxLength = input.maxLength;
  const warning = input.nextElementSibling; // Get the warning div after the input

  if (input.value.length >= maxLength) {
    input.value = input.value.slice(0, maxLength); // Trim excess text
    warning.classList.add("show");
    input.classList.add("warning-border");

    if ("vibrate" in navigator) {
      navigator.vibrate(100); // Mobile vibration for better UX
    }
    window.setTimeout(() => {
      warning.classList.remove("show");
      input.classList.remove("warning-border");
    }, 2000);
  }
}
/**
 * validate required fields in the form and make action on them like 
 * show warning border and message
 * @returns{boolean} valid or not
 */
export function validateRequiredFields() {
  const requiredFields = document.querySelectorAll('[required]');
  let isValid = true;

  requiredFields.forEach(field => {
    if (field.value.trim() === '') {
      isValid = false;
      field.classList.add('warning-border');
      const warning = field.nextElementSibling;
      if (!warning) return;
      warning.classList.add('show');
    } else {
      field.classList.remove('warning-border');
      const warning = field.nextElementSibling;
      if (!warning) return;
      warning.classList.remove('show');
    }
  });

  return isValid;
}
/**
 * validate the input of user for name field
 * @param {string} input text to validate
 * @param {boolean} isNumber the input of text is number
 * @returns 
 */
export function validateName(input, isNumber) {
  input = input.trim().replace(/\u200F/g, ""); // Remove RTL mark
  const emojiRegex = /[\uD83C-\uDBFF\uDC00-\uDFFF]+/g;

  // ——————————————————————
  // 1. Number-only mode
  // ——————————————————————
  if (isNumber) {
    if (input.length === 0) {
      return { isValid: false, message: "❌ يجب إدخال رقم" };
    }
    // Allow integers, decimals, and optional leading minus sign
    // Change the regex if you have different requirements (e.g. only positive integers)
    const numberRegex = /^[‑-]?[\d\u0660-\u0669]*\.?[\d\u0660-\u0669]+$/;
    if (!numberRegex.test(input)) {
      return { isValid: false, message: "❌ يجب أن تحتوي القيمة على أرقام فقط (  مثل 123 أو ١٢٣)" };
    }
    if (/^0\d+/.test(input) || /^-\d+\.$/.test(input)) {
      return { isValid: false, message: "❌ تنسيق الرقم غير صحيح" };
    }
    return { isValid: true, message: "✅ الرقم صالح" };
  }


  if (input.length === 0) {
    return { isValid: false, message: "❌ يجب إدخال الاسم" };
  }

  if (/^\s+$/.test(input)) {
    return { isValid: false, message: "❌ لا يمكنك استخدام المسافات فقط" };
  }

  if (input.length < 3 && isNumber === undefined) {
    console.log("isNumber : " + isNumber);
    return { isValid: false, message: "❌ الاسم قصير جدًا، يجب أن يحتوي على 3 أحرف على الأقل" };
  }

  if (/^\.+$/.test(input)) {
    return { isValid: false, message: "❌ لا يمكنك استخدام النقاط فقط" };
  }

  if (!/^[a-zA-Z0-9\u0600-\u06FF\s/()]+$/.test(input)) {
    return { isValid: false, message: "❌ يجب أن يحتوي الاسم على حروف (إنجليزية أو عربية)، أرقام، مسافات، أو الرموز / ( ) فقط" };
  }

  if (/(\p{L})\1{3,}/u.test(input)) {
    return { isValid: false, message: "❌ لا يمكنك تكرار نفس الحرف أكثر من 3 مرات متتالية" };
  }

  if (isNumber === undefined && /^\d+$/.test(input)) {
    return { isValid: false, message: "❌ لا يمكنك استخدام الأرقام فقط" };
  }

  if (emojiRegex.test(input)) {
    return { isValid: false, message: "❌ لا يمكنك استخدام الرموز التعبيرية" };
  }

  if (/[\p{C}]/u.test(input)) {
    return { isValid: false, message: "❌ لا يمكنك استخدام أحرف غير مرئية" };
  }

  return { isValid: true, message: "✅ الاسم صالح" };
}
/**
 * 
 * @param {string} str 
 * @returns 
 */
export function validateNumber(str) {
  // Regular expression to match both Western and Arabic numerals
  var regex = /^[0-9\u0660-\u0669]+$/;
  // Check if the input matches the regular expression
  return regex.test(str);
}
/**
 * 
 * @param {object} element 
 * @returns 
 */
export function markNotValid(element) {
  // Ensure we have a valid DOM element
  if (!element || !element.getBoundingClientRect) return;

  // Scroll to element with offset
  const offset = 350;
  const elementTop = element.getBoundingClientRect().top + window.pageYOffset;
  const targetScroll = elementTop - offset;

  window.scrollTo({
    top: targetScroll,
    behavior: 'smooth'
  });

  // Add invalid class
  element.classList.add("txt-notvalid");
}
/**
 * enable controls and add validation again
 * @param {string} enableControls 
 */
export function enableValidationFor(enableControls) {
  // reset all validation to non validation
  enableControls.forEach(crtl => {
    const element = document.getElementById(crtl);
    const nextElement = element?.nextElementSibling;

    element?.classList.remove("txt-notvalid");
    nextElement?.classList.remove("field-validation-valid");
    nextElement && (nextElement.textContent = "");
  });

  enableControls.forEach(ctrl => {
    const nextElement = document.getElementById(ctrl)?.nextElementSibling;
    nextElement?.classList.add("field-validation-valid");
  });
}



/**
 * Validates download attempts based on cookies and shows limit message if exceeded
 * @param {string} cookieName - Base cookie name (e.g., "design_123")
 * @param {number} ncounts - Max allowed attempts
 * @param {string} fbshare - Facebook share URL (currently not used in final message)
 * @returns {boolean} true = allowed to download, false = blocked
 */
export function validatCookie(cookieName, ncounts, fbshare) {
  // Helper: Safe parseInt
  const safeParseInt = (val) => (val ? parseInt(val, 10) : 0);

  const currentCount = safeParseInt(utils.getLocalStorageValue(cookieName));
  const balanceCount = safeParseInt(settingData?.general?.balanceCount) || 0;
  // const balanceCookieName = `${cookieName}balance`;
  // const balance = utils.getLocalStorageValue(balanceCookieName);

  let isValid = true;

  // Initialize cookie if doesn't exist
  if (!utils.getLocalStorageValue(cookieName)) {
    utils.setLocalStorageWithFlagExpiry(cookieName, 0);
  } else if (currentCount > ncounts) {
    isValid = false;
  }

  if (!isValid) {
    // === Time calculation for cooldown ===
    const now = new Date();
    const flag = utils.getCookie("_flag");
    const flagDate = flag ? new Date(flag) : now;

    let dif, isHourUnit = true;
    if (flagDate > now) {
      const diffMs = flagDate - now;
      dif = Math.floor(diffMs / (1000 * 60 * 60)); // hours
      if (dif < 1) {
        dif = Math.floor(diffMs / (1000 * 60)); // minutes
        isHourUnit = false;
      }
    } else {
      dif = 0;
    }

    // I may have synatx errors but I cannot see it here , for example
    //may I call a function from a module and this function not belong to it and for other module but editor not raise error in development , please review this module that all called functions belong to it's modules like ui.hideDomByClassName I was wrong and write utils.hideDomByClassName
    // === DOM Updates (safe vanilla JS) ===
    ui.hideDomByClassName("loader-container");
    document.querySelector(".image-designed")?.replaceChildren(); // Clear
    document.querySelector(".fb-shared")?.replaceChildren();
    document.querySelector(".message")?.replaceChildren();

    // === Extra message if user didn't share ===
    //const noShareStatus = "no-share"; // adjust if needed
    const hasShared = utils.getLocalStorageValue(`${config.noShareStatus}-${config.designName}`) === null;
    const lastChance = utils.getLocalStorageValue(`${config.lastChance}-${config.designName}`) === null;
    const extraMessage = !hasShared ? `
      <p class="mt-2 p-2" style="font-size:1.2rem; color:#155724;margin-bottom:0!important; background-color:#d4edda; border:1px solid #c3e6cb; border-radius:5px;">
        <i class="fas fa-info-circle"></i> قد يكون السبب هو <strong>رفض المشاركة</strong>، لأن المشاركة تعطيك <strong>  العديد من المحاولات</strong>.
        
      </p>${lastChance ? `<a href="#" class="btn btn-primary mt-2" style="padding:13px;" onclick="window.resetTries()">أضغط هنا للحصول على محاولة أخيرة </a>` : ''}` : '';

    // === Device-specific messages ===
    const timeUnit = isHourUnit ? 'ساعة' : 'دقيقة';
    const phoneMessage = `<p style="font-size:1.1rem">يمكنك الانتظار والعودة إلى الموقع بعد ${dif} ${timeUnit} من الآن.</p>`;
    const pcMessage = `
      <p style="font-size:1.1rem">يمكنك تصفح الموقع بشكل أفضل من الهاتف المحمول للحصول على المزيد من التصميمات المجانية.</p>
      <p class="mt-3" style="font-size:1.1rem">يمكنك الانتظار والعودة إلى الموقع بعد ${dif} ساعات من الآن.</p>`;

    const errorHTML = `
      <div class="text-center">
        <div class="alert alert-danger" role="alert">
          <i class="fas fa-exclamation-triangle fa-3x"></i>
          <p class="mt-3" style="font-size:1.3rem">عفوا، لقد نفذت عدد المحاولات في هذا التصميم.</p>
          ${extraMessage}
          ${!utils.isDesktop() ? phoneMessage : pcMessage}
        </div>
      </div>`;

    // Apply error message
    const imageContainer = document.querySelector(".image-designed");


    const boxContainer = document.querySelector(".box-container");
    if (imageContainer) {

      imageContainer.innerHTML = errorHTML;
      imageContainer.style.display = "block";
    }
    if (boxContainer) {
      boxContainer.style.minHeight = "0";
    }

    // Clear desktop warning if on desktop
    if (utils.isDesktop()) {
      document.querySelector('.desktop-warning')?.replaceChildren();
    }

    // === Log user exceed (analytics) ===
    const ip = utils.getCookie("ip") || "";
    const country = utils.getCookie("country") || "";
    const device = navigator.userAgent;
    const url = window.location.href;

    const totalDownload = safeParseInt(utils.getCookie(config.totaldowloadKey));
    const isExceedTotal = totalDownload >= config.maxTotalDownloadPerCountry ? 1 : 0;

    const logUser = utils.createLogUser(
      { ip, loc: country, uag: device },
      url
    );

    logUser.isExceedDesign = 1;
    logUser.isExceedTotalDownload = isExceedTotal;
    logUser.flag = flag || "";
    logUser.totalDownload = totalDownload;
    logUser.totalDesigns = currentCount;

    apihandler.logUsersOfDesign(logUser);

    return false; // Blocked
  }

  return true; // Allowed
}
//========End of Validation Functions ========//